import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppTextField = _resolveComponent("AppTextField")!

  return (_openBlock(), _createBlock(_component_AppTextField, {
    value: _ctx.value,
    type: _ctx.type,
    "validation-state": _ctx.validationState,
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    readonly: _ctx.readonly,
    formatter: _ctx.formatter,
    inputmode: _ctx.inputmode,
    onFocus: _ctx.onFocus,
    onInput: _ctx.onInput,
    onBlur: _ctx.onBlur,
    maxlength: "2",
    class: "time-input text-center"
  }, null, 8, ["value", "type", "validation-state", "placeholder", "disabled", "readonly", "formatter", "inputmode", "onFocus", "onInput", "onBlur"]))
}